<template>
	<section
		class="section"
		:id="node.sectionId"
		:data-key="node.key"
		v-bind:class="[
			{
				'section-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:style="getContainerStyle(node)"
	>

		<NodeAction :node="node" component="section" v-if="!onPreview" />

		<div
			:id="node.id"
			:data-key="node.key"
			:class="className"
			:data-row="node.children.length">
			<template v-if="node.children && node.children.length > 0">
				<draggable
					:list="node.children"
					:animation="200"
					@start="onDragRow"
					@end="onEndDragRow"
					handle=".row-handle">
					<NodeTree
						v-for="(child, i) in node.children"
						:node="child"
						:key="i"
						:onPreview="onPreview"
						:previewDevice.sync="previewDevice"
						:settings="settings"
					/>
				</draggable>
			</template>
			<template v-else>
				<div
					class="column-empty-view"
					v-tooltip="'Add New Row'"
					@click="addRow"
				>
					<div class="column-empty-view__first-add">
						<i class="material-icons d-block">add</i>
					</div>
				</div>
			</template>
		</div>
	</section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	generateRandomString,
	getNodeStyle,
	duplicateVar,
// eslint-disable-next-line
} from '@/lib/helper';

import {
	rowSkeleton,
	columnSkeleton,
// eslint-disable-next-line
} from '@/lib/statics';

export default {
	name: 'NodeContainer',
	props: ['node', 'onPreview', 'previewDevice', 'settings'],
	components: {
		draggable,
		NodeAction,
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			pageHistories: 'funnels/pageHistories',
		}),
		className() {
			return this.getContainerClass(this.node);
		},
		style() {
			return this.getContainerStyle(this.node);
		},
		sectionId() {
			const sectionId = this.node.sectionId;
			return sectionId;
		},
	},
	methods: {
		...mapActions({
			setPageEditorHistory: 'funnels/setPageEditorHistory',
			setIsDragging: 'funnels/setIsDragging',
		}),
		getContainerClass({ options }) {
			let cClass = 'container';
			if (options && options.type && options.type === 'fluid') {
				cClass = 'container-fluid';
			}

			return cClass;
		},
		getContainerStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'margin',
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'bg-color',
				'border',
				'bg-img',
				'box-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
		addRow() {
			const currentSection = this.node;
			const parentId = currentSection.id;
			const parentKey = currentSection.key;
			const rowId = `row_${generateRandomString()}`;
			const colId = `col_${generateRandomString()}`;

			const newRow = duplicateVar(rowSkeleton);
			newRow.id = rowId;
			newRow.key = rowId;
			newRow.parentId = parentId;
			newRow.parentKey = parentKey;

			const newColumn = duplicateVar(columnSkeleton);
			newColumn.id = colId;
			newColumn.key = colId;
			newColumn.parentId = rowId;
			newColumn.parentKey = rowId;
			newRow.children = [newColumn];

			this.node.children.push(newRow);
			this.$bus.$emit('refresh-jquery');
			this.$bus.$emit('node-tree-change', 'row', 'added');
		},
		// update tree data for history list purpose
		updateHistory(label, action = '') {
			const history = {
				label,
				action,
				data: this.node,
				time: '',
			};
			const histories = [history, ...this.pageHistories];
			this.setPageEditorHistory(histories);
		},
		onDragRow() {
			this.setIsDragging(true);
		},
		onEndDragRow() {
			this.setIsDragging(false);
		},
	},
};
</script>
